/* src/app/image-modal/image-modal.component.scss */
.image-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.8);
  height: 100%;
}
img {
  max-width: 90%;
  max-height: 90%;
  border-radius: 8px;
  object-fit: contain;
}
/*# sourceMappingURL=image-modal.component.css.map */
